import React from 'react'
import { Dropdown } from 'react-bootstrap'
import classNames from 'classnames'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import {
  selectCrossClientLandingSelectedOwnerId,
  selectCrossClientLandingTeammates,
  selectCrossClientLandingTeammatesLoading,
  setCrossClientLandingSelectedOwnerId,
} from '../../../../store/crossClient/crossClientLanding'
import { selectSafeAuthenticatedUser } from '../../../../store/auth/authSlice'
import { getUserDisplayName } from '../../../../apps/professional-app/fa/common/aifeatures/utils'
import './CrossClientOwnerFilter.scss'

const ALL_USERS_LABEL = 'All users'

export const CrossClientOwnerFilter: React.FC = () => {
  const dispatch = useAppDispatch()

  const teammates = useAppSelector(selectCrossClientLandingTeammates)
  const teammatesLoading = useAppSelector(selectCrossClientLandingTeammatesLoading)
  const selectedOwnerId = useAppSelector(selectCrossClientLandingSelectedOwnerId)
  const currentUser = useAppSelector(selectSafeAuthenticatedUser)

  const teammateLabel = (teammate: (typeof teammates)[number]): string => `${getUserDisplayName(teammate)}${teammate.id === currentUser.id ? ' (You)' : ''}`

  const selectedTeammate = selectedOwnerId ? teammates.find((teammate) => teammate.id === selectedOwnerId) : null
  const selectedLabel = selectedTeammate ? teammateLabel(selectedTeammate) : ALL_USERS_LABEL

  const handleSelect = (ownerId: string | null) => {
    if (ownerId === selectedOwnerId) {
      return
    }
    dispatch(setCrossClientLandingSelectedOwnerId(ownerId))
  }

  return (
    <Dropdown>
      <Dropdown.Toggle
        as='button'
        type='button'
        bsPrefix='cross-client-owner-filter'
        className='d-flex gap-2 align-items-center bg-white border zocks-border-color-gray-400 cross-client-owner-filter'
        disabled={teammatesLoading}
      >
        <i className='bi bi-funnel zocks-text-gray-700' />
        <span className='paragraph-small bold zocks-text-gray-900 text-truncate flex-grow-1 text-start'>{selectedLabel}</span>
        <i className='bi bi-chevron-expand zocks-text-gray-700' />
      </Dropdown.Toggle>
      <Dropdown.Menu className='cross-client-owner-filter-menu'>
        <Dropdown.Item as='button' type='button' className={classNames('paragraph-small', { 'fw-bold': !selectedOwnerId })} onClick={() => handleSelect(null)}>
          {ALL_USERS_LABEL}
        </Dropdown.Item>
        {teammates.map((teammate) => (
          <Dropdown.Item
            key={teammate.id}
            as='button'
            type='button'
            className={classNames('paragraph-small text-truncate', { 'fw-bold': selectedOwnerId === teammate.id })}
            onClick={() => handleSelect(teammate.id)}
          >
            {teammateLabel(teammate)}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}
